import { memo } from "react";
import { PayrollRecordView } from "./PayrollRecordView";
import { PayrollActionLinks } from "./PayrollActionLinks";

export const PayrollSplitRecordView = memo(() => (
  <PayrollRecordView
    className="mb-4"
    actions={[
      <PayrollActionLinks splitOptions={{ isBold: true, isDisabled: true }} />,
    ]}
  />
));

PayrollSplitRecordView.displayName = "PayrollSplitRecordView";
